 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"52930e64","chunk-09155df3":"2e268433","chunk-09162720":"9a851566","chunk-097e0872":"81c1f0c0","chunk-0e93a01c":"16448226","chunk-1a7785d2":"ce8500fe","chunk-1bff95de":"de12714f","chunk-1c4705f4":"e1cb334d","chunk-1dbc15a2":"17123dc0","chunk-21a76241":"2bbaf8c0","chunk-25d83ca8":"1d971486","chunk-2d0a463b":"68f3e520","chunk-2d0ac931":"667708a1","chunk-2d0c073f":"50e276e1","chunk-2d0c211b":"b0b6c231","chunk-2d0cf315":"8bdd27d5","chunk-2d0d43da":"c6672c38","chunk-2d0d5c33":"d98bbfcf","chunk-2d0da04a":"50e3fbb9","chunk-2d0e5812":"59c57da3","chunk-2d213189":"37da8e05","chunk-2d217def":"a644b19b","chunk-2d217e6a":"9d5e5387","chunk-2d218068":"7765ed58","chunk-2d21a9aa":"51f415cb","chunk-2d21da73":"3021a7fc","chunk-2d222cca":"eaa1fa6a","chunk-2d22895d":"006e634b","chunk-2d23721e":"b3beb5de","chunk-2d237b00":"037b5772","chunk-30dd9750":"7cb8f4a8","chunk-37f2300e":"06cd27a8","chunk-3ed29de3":"6d1e139c","chunk-41c0f7a4":"5198d285","chunk-426f2f16":"7e1aff2d","chunk-462c869e":"04c2fe5c","chunk-47245a33":"b9e6a322","chunk-4739acd0":"5f4b483a","chunk-483f4cd2":"59dbf39b","chunk-53b1137a":"a3202169","chunk-541ea42d":"42e37721","chunk-54bbd082":"03a33148","chunk-59d4c87c":"b31e07fc","chunk-5a8ac886":"6ef42fef","chunk-5ff96a24":"e1b9f3fb","chunk-69eb8776":"5096f8b2","chunk-6d375f34":"e8cf08c2","chunk-6e83591c":"43f6310a","chunk-504a075e":"8c4b596e","chunk-bbc714a0":"d0760625","chunk-6ff34d29":"d56e0c3f","chunk-01fa52d9":"4fb4bda8","chunk-140c7a93":"86465db6","chunk-27fd01c2":"14c76568","chunk-04db21d1":"58094e99","chunk-18cdf565":"0f59b252","chunk-6337fcfc":"a913678c","chunk-122b7d09":"86e2e150","chunk-37523ec4":"681b61fa","chunk-3a4cac0f":"b23ddcb4","chunk-3b20a216":"e5a3578e","chunk-5f3a3f30":"a14c513a","chunk-69092b70":"0488c55a","chunk-7fb19599":"60fe73c9","chunk-5bd8bc88":"13a794b4","chunk-617915a6":"829c179b","chunk-c18a7b7a":"86a531a1","chunk-03e07872":"c5083062","chunk-4596b982":"ac5188ef","chunk-e10cf6d6":"ef650ea9","chunk-58b068d6":"e3761a16","chunk-70e11de4":"d3bc3566","chunk-3384634f":"e08e6f2e","chunk-2785f282":"3cd1e2be","chunk-183ef132":"e7c6df69","chunk-747713ce":"b6587392","chunk-7d1f8883":"2ce7bedf","chunk-89fb86ce":"1bb06069","chunk-8d9f9b5c":"d585daf6","chunk-9074b70e":"1fcf2337","chunk-c56932d8":"6c9ef945","chunk-c61962c6":"1c3145f3","chunk-0909218d":"ba720ad7","chunk-7dffc1a6":"b3e4d184","chunk-27e5f7d1":"8389a941","chunk-e6098798":"f9f832bc","chunk-44dd7e15":"39cc7636","chunk-7548ca2d":"46776066","chunk-79f1dac7":"c4d9090c","chunk-858cd918":"75bbbcad","chunk-8bb7f81e":"1979a9e9","chunk-a9395c36":"6457a75a","chunk-d0e8aa0a":"9263166d","chunk-d8413eac":"2558759c","chunk-e5275ddc":"c05297dd","chunk-eaa2b130":"4044edc0","polyfills-core-js":"12be3461","polyfills-dom":"662760da","stencil-polyfills-css-shim":"95cbdafc","stencil-polyfills-dom":"f9377d9e","chunk-2d0c9adc":"7b72019c","chunk-2d0c9758":"62f099a9","chunk-2d0b33e3":"2e69defc","chunk-2d0b9074":"cf6d8bbf","chunk-2d0b9280":"58416f48","chunk-2d0baac9":"ecbd8a2b","chunk-2d2376e6":"a05b70ee","chunk-2d216786":"97e8ffc1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1a7785d2":1,"chunk-483f4cd2":1,"chunk-bbc714a0":1,"chunk-01fa52d9":1,"chunk-140c7a93":1,"chunk-04db21d1":1,"chunk-18cdf565":1,"chunk-122b7d09":1,"chunk-37523ec4":1,"chunk-3a4cac0f":1,"chunk-3b20a216":1,"chunk-5f3a3f30":1,"chunk-69092b70":1,"chunk-7fb19599":1,"chunk-5bd8bc88":1,"chunk-617915a6":1,"chunk-c18a7b7a":1,"chunk-03e07872":1,"chunk-4596b982":1,"chunk-58b068d6":1,"chunk-70e11de4":1,"chunk-3384634f":1,"chunk-2785f282":1,"chunk-183ef132":1,"chunk-747713ce":1,"chunk-7d1f8883":1,"chunk-89fb86ce":1,"chunk-8d9f9b5c":1,"chunk-9074b70e":1,"chunk-c56932d8":1,"chunk-c61962c6":1,"chunk-0909218d":1,"chunk-7dffc1a6":1,"chunk-27e5f7d1":1,"chunk-e6098798":1,"chunk-44dd7e15":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-1a7785d2":"9c654cd9","chunk-1bff95de":"31d6cfe0","chunk-1c4705f4":"31d6cfe0","chunk-1dbc15a2":"31d6cfe0","chunk-21a76241":"31d6cfe0","chunk-25d83ca8":"31d6cfe0","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0d5c33":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-30dd9750":"31d6cfe0","chunk-37f2300e":"31d6cfe0","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-426f2f16":"31d6cfe0","chunk-462c869e":"31d6cfe0","chunk-47245a33":"31d6cfe0","chunk-4739acd0":"31d6cfe0","chunk-483f4cd2":"1f5d896e","chunk-53b1137a":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-69eb8776":"31d6cfe0","chunk-6d375f34":"31d6cfe0","chunk-6e83591c":"31d6cfe0","chunk-504a075e":"31d6cfe0","chunk-bbc714a0":"cc19ab5b","chunk-6ff34d29":"31d6cfe0","chunk-01fa52d9":"42ac6c4b","chunk-140c7a93":"0fcd3585","chunk-27fd01c2":"31d6cfe0","chunk-04db21d1":"aa4b704d","chunk-18cdf565":"44737700","chunk-6337fcfc":"31d6cfe0","chunk-122b7d09":"03401e3b","chunk-37523ec4":"82cd6933","chunk-3a4cac0f":"b2028f7f","chunk-3b20a216":"0b4f0612","chunk-5f3a3f30":"f29cae85","chunk-69092b70":"2a74669d","chunk-7fb19599":"5e182dc2","chunk-5bd8bc88":"66ef3b70","chunk-617915a6":"46caad49","chunk-c18a7b7a":"f24fda57","chunk-03e07872":"c7e617f3","chunk-4596b982":"60fc3493","chunk-e10cf6d6":"31d6cfe0","chunk-58b068d6":"95f16e44","chunk-70e11de4":"b9fe4df7","chunk-3384634f":"e4358697","chunk-2785f282":"0d300137","chunk-183ef132":"e7102aab","chunk-747713ce":"497e3603","chunk-7d1f8883":"9c9e8fb1","chunk-89fb86ce":"c1f8e2e9","chunk-8d9f9b5c":"9abedda7","chunk-9074b70e":"f61595c7","chunk-c56932d8":"998f2e39","chunk-c61962c6":"2700ce36","chunk-0909218d":"9cbca5cb","chunk-7dffc1a6":"cc52404b","chunk-27e5f7d1":"019ca7ae","chunk-e6098798":"48764037","chunk-44dd7e15":"b39709ee","chunk-7548ca2d":"31d6cfe0","chunk-79f1dac7":"31d6cfe0","chunk-858cd918":"31d6cfe0","chunk-8bb7f81e":"31d6cfe0","chunk-a9395c36":"31d6cfe0","chunk-d0e8aa0a":"31d6cfe0","chunk-d8413eac":"31d6cfe0","chunk-e5275ddc":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d0c9adc":"31d6cfe0","chunk-2d0c9758":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0b9074":"31d6cfe0","chunk-2d0b9280":"31d6cfe0","chunk-2d0baac9":"31d6cfe0","chunk-2d2376e6":"31d6cfe0","chunk-2d216786":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
